export function useStructuredProduct(product, price, new_availabilities) {
  const runtimeConfig = useRuntimeConfig()
  const main_url = `${runtimeConfig.public.domain}`
  let products_json = []
  const priceValidUntil = new Date()
  priceValidUntil.setUTCHours(0, 0, 0, 0)
  priceValidUntil.setUTCDate(priceValidUntil.getUTCDate() + 30)
  const priceValidUntilValue = priceValidUntil.toISOString().split('T')[0]

  const availabilitiesRaw = new_availabilities?.value ?? []
  const productChildrenRaw = product?.children ?? []

  if (!product) {
    return
  }

  const availabilities = [
    ...new Map(
      availabilitiesRaw
        .filter(a => a?.id != null)
        .map(a => [a.id, a]),
    ).values(),
  ]
  const productChildren = [
    ...new Map(
      productChildrenRaw
        .filter(child => child?.id != null)
        .map(child => [child.id, child]),
    ).values(),
  ]

  if (product.structure === 'parent') {
    const childrenById = new Map(productChildren.map(child => [child.id, child]))

    for (const child of availabilities) {
      const product_child = childrenById.get(child.id)
      if (!product_child) {
        continue
      }

      let name = null
      if (product_child.custom_google_feed_title) {
        name = product_child.custom_google_feed_title
      }
      else if (product.custom_google_feed_title) {
        name = [
          product.custom_google_feed_title,
          product_child.cut?.title,
          `${product_child.cut?.weight ?? ''}${product_child.cut?.unit ?? ''}`,
        ]
          .filter(Boolean)
          .join(' ')
      }
      else {
        name = [
          product.title,
          product_child.cut?.title,
          `${product_child.cut?.weight ?? ''}${product_child.cut?.unit ?? ''}`,
        ]
          .filter(Boolean)
          .join(' ')
      }

      products_json.push({
        '@context': 'https://schema.org/',

        '@type': 'Product',

        'sku': product_child.upc,

        'image': [product?.images[0]?.src],

        'name': name,

        'description': product?.description,

        'brand': {
          '@type': 'Brand',

          'name': 'LUMA Delikatessen',
        },
        'offers': {
          '@type': 'Offer',
          'availability': child.is_available_to_buy
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
          'itemCondition': 'https://schema.org/NewCondition',
          'url': `${main_url}${product.html_url}?variant=${product_child.id}`,
          'priceCurrency': child.currency,

          'price': child.action
            ? child.incl_tax
            : child.original_incl_tax,
          'priceValidUntil': priceValidUntilValue,
        },
      })
    }
  }
  else {
    const current_product_availability = availabilities[0] // Only one Product in new_availabilities -> Standalone
    if (!current_product_availability) {
      return
    }
    let name = null
    if (product.custom_google_feed_title) {
      name = product.custom_google_feed_title
    }
    else {
      name = `${product?.title}`
    }
    products_json = {
      '@context': 'https://schema.org/',

      '@type': 'Product',

      'sku': product?.upc,

      'image': [product?.images[0]?.src],

      'name': name,

      'description': product?.description,

      'brand': {
        '@type': 'Brand',

        'name': 'LUMA Delikatessen',
      },
      'offers': {
        '@type': 'Offer',
        'availability': current_product_availability.is_available_to_buy
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
        'itemCondition': 'https://schema.org/NewCondition',

        'priceCurrency': current_product_availability?.currency,

        'price': current_product_availability?.action
          ? current_product_availability?.incl_tax
          : current_product_availability?.original_incl_tax,
        'priceValidUntil': priceValidUntilValue,
      },
    }
  }
  useJsonld(products_json)
}
